module.exports = __webpack_public_path__ + "static/media/IconTemplates_-90.db649843.svg";